/**
 * The only types WinDocs will render inline, and the exact MIME string each is
 * rendered as.
 *
 * This table is the client half of a two-sided guarantee. The API verifies a
 * file's signature on upload and refuses to serve anything outside its own
 * allowlist inline; the viewer then re-types the bytes it receives from *this*
 * table rather than from the response, so the blob handed to the browser
 * carries a type the app chose. Even a compromised or misconfigured server
 * cannot get `text/html` into an element on this origin through the viewer.
 *
 * Keep it in step with PREVIEWABLE_MIME_TYPES in the backend storage module.
 * SVG is absent on purpose: it is an XML document that can carry script, so it
 * would be a web page wearing an image's extension.
 */
export const RENDERABLE_TYPES: Record<string, 'image' | 'pdf'> = {
  'application/pdf': 'pdf',
  'image/jpeg': 'image',
  'image/png': 'image',
  'image/gif': 'image',
  'image/webp': 'image',
};

/** Whether the in-app viewer can show this type, rather than download it. */
export function isPreviewable(mimeType: string): boolean {
  return mimeType in RENDERABLE_TYPES;
}
